import { useEffect, useState } from "react";

import { firestore } from "../../../init/firebase";
import useCurrentUser from "../../../hooks/useCurrentUser";
import { AppResource } from "../../../types/resource.types";
import { User, UserRole } from "../../../types/user.types";

/**
 * this function is used to get current logged-in user fcm token path
 * will be used for save the `generated FCM token from mobile` when the webview is started
 * */
export const prepareUserFcmTokenRef = (user: User) => {
  return firestore
    .collection(
      `${user.path}/${
        user.role === UserRole.gym
          ? AppResource.gyms
          : user.role === UserRole.academy
          ? AppResource.academies
          : user.role === UserRole.entertainment
          ? AppResource.entertainments
          : user.role === UserRole.coach
          ? AppResource.coaches
          : user.role === UserRole.sportClub
          ? AppResource.sportsClubs
          : user.role === UserRole.store
          ? AppResource.brands
          : ""
      }Tokens`
    )
    .doc(AppResource.fcm);
};

export const useGetUserFcmTokensRef = () => {
  const { user } = useCurrentUser();
  const [tokensCollection, setTokensCollection] = useState<any>(null);

  useEffect(() => {
    if (user.id && user.role !== UserRole.admin) {
      setTokensCollection(prepareUserFcmTokenRef(user));
    }
  }, [user]);

  return tokensCollection;
};
